// extracted by css-extract-rspack-plugin
export default {"container":"load-more-items-module__container___KPs_a","link":"load-more-items-module__link___AciWk common-module__link___I7lvk","caret":"load-more-items-module__caret___f1kz9"};